import {SxProps} from '@mui/material';

// the styling for the powered by container
export const poweredByContainer: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
